// Single source of truth for the mobile layout breakpoint and the small
// cross-component events used by the mobile layout.
// Keep MOBILE_MAX_WIDTH_PX in sync with $mobile-breakpoint-max (991.98px)
// in assets/scss/_mobile.scss.

export const MOBILE_MAX_WIDTH_PX = 991;

// Fired by the mobile footer bar ("More") and handled by the Header, which owns
// the menu. detail.open (boolean) forces a state; without it the menu toggles.
export const HEADER_MENU_EVENT = 'focus:header-menu';

export const isMobileViewport = () => window.innerWidth <= MOBILE_MAX_WIDTH_PX;

export const setHeaderMenuOpen = open =>
  window.dispatchEvent(
    new CustomEvent(HEADER_MENU_EVENT, {
      detail: typeof open === 'boolean' ? { open } : {}
    })
  );

// Fingers are far less precise than a mouse. On touch devices a map tap counts
// as a hit when a feature lies within this radius (half the touch target size).
export const TOUCH_HIT_RADIUS_PX = 22;

export const isCoarsePointer = () =>
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(pointer: coarse)').matches;

// Lets any component ask Home to switch the mobile view ('filters' | 'map' |
// 'results'), e.g. after an observation is selected on the map or in the list.
// Does nothing on desktop, where all panes are visible at once.
export const MOBILE_VIEW_EVENT = 'focus:mobile-view';

export const requestMobileView = view => {
  if (!isMobileViewport()) return;
  window.dispatchEvent(new CustomEvent(MOBILE_VIEW_EVENT, { detail: { view } }));
};
